import React from 'react';
import {
    Box,
    Button,
    Flex,
    IconButton,
    ScrollArea,
    Select,
    TextField,
    Text,
} from '@radix-ui/themes';
import { FormField } from 'shared/components';
import { AddIcon, ClearIcon } from 'shared/icons';
import { observer } from 'mobx-react-lite';
import { useCreateResumeContext } from 'candidate/feature-create-resume/create-resume.context';
import { LinkedFieldRow } from '../ui/linked-field-row';

export const LinkedMessengers = observer(() => {
    const { contactInfoStore } = useCreateResumeContext();
    const linkedMessengers = contactInfoStore.linkedMessengers;
    // const validation = FormService.validate<{
    //     messengers: string[];
    //     control: MessengerControl;
    // }>(
    //     {
    //         control: contactInfoCtx.messengerControl,
    //         messengers: contactInfoCtx.messengers,
    //     },
    //     MessengerValidationSchema
    // );

    return (
        <Box className="messengers-list-container">
            <LinkedFieldRow
                key="messenger"
                fields={[
                    <FormField label="Мессенджер" key="messengerSelect">
                        <Select.Root
                            size="3"
                            value={linkedMessengers.messengerControl.selectValue}
                            onValueChange={(value) =>
                                linkedMessengers.messengerControl.onSelectChange(value)
                            }
                        >
                            <Select.Trigger
                                placeholder={
                                    linkedMessengers.messengerControl.selectPlaceholder
                                }
                            ></Select.Trigger>
                            <Select.Content position="popper">
                                {linkedMessengers
                                    .availableMessengers(linkedMessengers.messengerControl)
                                    .map((messenger) => {
                                        return (
                                            <Select.Item key={messenger} value={messenger}>
                                                {messenger}
                                            </Select.Item>
                                        );
                                    })}
                            </Select.Content>
                        </Select.Root>
                    </FormField>,
                    <FormField
                        label={linkedMessengers.messengerControl.label}
                        error={linkedMessengers.messengerControl.error}
                        key="messengerInput"
                    >
                        <TextField.Root
                            size="3"
                            value={linkedMessengers.messengerControl.viewValue}
                            placeholder={linkedMessengers.messengerControl.placeholder}
                            type={linkedMessengers.messengerControl.inputType}
                            onChange={(e) => {
                                linkedMessengers.messengerControl.onInputChange(
                                    e.target.value
                                );
                            }}
                        ></TextField.Root>
                    </FormField>,
                ]}
                action={
                    <Button
                        size="3"
                        className="add-messenger-trigger"
                        variant="outline"
                        type="button"
                        onClick={() => linkedMessengers.addMessanger()}
                    >
                        <Text weight="regular" wrap="nowrap">Додати ще</Text>
                        <AddIcon />
                    </Button>
                }
            />

            <Box pt="4">
                <ScrollArea scrollbars="vertical" type="always" style={{ maxHeight: 200 }}>
                    <Flex gap="4" direction="column">
                        {linkedMessengers.messengersControls.map((control) => {
                            return (
                                <Flex gap="4" pr="100px" align="end" key={control.id}>
                                    <FormField label="Мессенджер">
                                        <Select.Root
                                            size="3"
                                            value={control.selectValue}
                                            onValueChange={(value) => {
                                                control.onSelectChange(value);
                                            }}
                                        >
                                            <Select.Trigger></Select.Trigger>
                                            <Select.Content position="popper">
                                                {linkedMessengers
                                                    .availableMessengers(control)
                                                    .map((messenger) => {
                                                        return (
                                                            <Select.Item
                                                                key={messenger}
                                                                value={messenger}
                                                            >
                                                                {messenger}
                                                            </Select.Item>
                                                        );
                                                    })}
                                            </Select.Content>
                                        </Select.Root>
                                    </FormField>

                                    <FormField label={control.label}>
                                        <TextField.Root
                                            value={control.viewValue}
                                            placeholder={control.placeholder}
                                            onChange={(e) => {
                                                control.onInputChange(e.target.value);
                                            }}
                                            size="3"
                                        ></TextField.Root>
                                    </FormField>

                                    <IconButton
                                        size="3"
                                        type="button"
                                        variant="outline"
                                        onClick={() =>
                                            linkedMessengers.removeMessenger(control.id)
                                        }
                                    >
                                        <ClearIcon />
                                    </IconButton>
                                </Flex>
                            );
                        })}
                    </Flex>
                </ScrollArea>
            </Box>
        </Box>
    );
});
